import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'codepostal',
  standalone: false,
})
export class CodepostalPipe implements PipeTransform {
  transform(value: string): string {
    const formated = value.substring(0, 3);
    return `${formated} ${value.substring(3)}`;
  }
}
